// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ntext[data-v-55db81c1] {\n  pointer-events: none;\n  font-weight: bold;\n  font-size: 1.1em;\n  fill: 'primary';\n}\nrect[data-v-55db81c1] {\n  fill: none;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
